import MemberVisitsReducer from "./redux/memberVisitsReducer";
import MemberVisitsSaga from "./redux/memberVisitsSaga";
import { MemberVisitsModule } from "./memberVisitsModule";

export default {
  Component: MemberVisitsModule,
  moduleName: "memberVisits",
  saga: MemberVisitsSaga(),
  reducer: MemberVisitsReducer
};
